import { render } from "./ReaderMetadata.vue?vue&type=template&id=de265b32"
import script from "./ReaderMetadata.vue?vue&type=script&lang=js"
export * from "./ReaderMetadata.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__